$ = require 'jquery'
Action = require 'models/action'
ActionList = require 'models/collections/action-list'
ActionListView = require 'views/action/action-list-view'
Auth = require 'db/auth'
Backgrounds = require 'data/backgrounds'
BoardMembersView = require 'views/board-menu/board-members-view'
BoardSelectOrganizationView = require 'views/board-menu/board-select-organization-view'
ChangeBoardVisibilityView = require 'views/board-menu/change-board-visibility-view'
DragSort = require 'views/lib/drag-sort'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
MemberOnBoardView = require 'views/member-menu-profile/member-on-board-view'
MemberFullNameOnBoardView = require 'views/member-menu-profile/member-full-name-on-board-view'
ModelLoader = require 'db/model-loader'
BoardMenuMoreView = require 'views/board-menu/board-menu-more-view'
PopOver = require 'views/lib/pop-over'
Storage = require 'lib/storage'
Util = require 'lib/util'
View = require 'view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
templates = require 'views/internal/templates'
boardMenuTemplate = require 'views/templates/board_menu_default'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
simpleTest = require 'lib/experiments/simple-test'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'
formatNumber = require 'lib/format/number'
logError = require 'debug/log-error'
mixin = require 'lib/mixin'
ViewWithActions = require 'views/internal/view-with-actions'
LatestPowerUpsMessage = require 'data/latest-power-ups-message'
ClientConfig = require 'debug/client-config'

module.exports = class BoardSidebarDefaultView extends View
  mixin ViewWithActions, @
  viewTitleKey: ->
    if simpleTest('tabbedBoardMenu')?.get('tabbed')
      'people'
    else
      'menu'

  viewIcon: 'member'

  className: 'board-menu-content-frame'

  headerDisplayTypeClass: 'is-board-menu-default-view'
  isTopLevelTab: true

  initialize: ({ @sidebarView }) ->
    @showAllMembers = simpleTest('tabbedBoardMenu')?.get('tabbed')

    @numActionsToShow = 15

    @makeDebouncedMethods 'render', 'renderMembers'

    @listenTo @model.memberList,
      'change:status': @renderMembersDebounced
      'add remove reset': @renderDebounced

    @listenTo @model,
      'change:datePluginDisable': @renderPowerUpDisableTimer
      'change:memberships': @renderDebounced
      'change:prefs.canInvite': @renderDebounced
      'change:prefs.selfJoin': @renderDebounced
      'change:prefs.invitations': @renderDebounced
      'change:prefs.permissionLevel': @renderDebounced
      'change:powerUps': @renderEnabledPowerUpCount
      'change:idOrganization': @renderDebounced

    @listenTo Auth.me(),
      'change:idOrganizations': @loadOrganizationMembersData

    @listenTo @model.boardPluginList,
      'add remove reset': @renderEnabledPowerUpCount

    @setOrganizationChangeListener()

    @subscribe pluginsChangedSignal(@model), => @renderEnabledPowerUpCount()

    if !simpleTest('tabbedBoardMenu')?.get('tabbed')
      @actionListView = @collectionSubview ActionListView, new ActionList([], { @modelCache }),
        renderOpts:
          limit: @numActionsToShow
          context: @model
          compact: true
          truncateComments: (action) =>
            action.get('date') < @model.get('dateLastView')
          excludeTypes: ['copyCommentCard']

      @waitForId @model, =>
        @listenTo @modelCache, "add:Action:#{ @model.id } remove:Action:#{ @model.id } change:Action:#{ @model.id }", @frameDebounce =>
          @renderActionCount()
          @actionListView.collection.reset(@getActions())

        @actionListView.collection.reset(@getActions())

  events:
    'click .js-open-manage-board-members': 'openAddMembers'
    'click .js-show-extra-members': 'showExtraMembers'
    'click .js-hide-extra-members': 'hideExtraMembers'
    'click .js-join-board': 'joinBoard'
    'click .js-change-background': 'changeBackground'
    'click .js-open-power-ups': 'showPowerUps'
    'click .js-open-stickers': 'openStickers'
    'click .js-open-card-filter': 'showCardFilter'
    'click .js-open-activity': 'openActivity'
    'click .js-open-more': 'openMore'
    'click .js-close-highlight-add-members': (e) ->
      Auth.me().dismiss(@_highlightAddMembersKey())
      @renderMembers()
    'click .js-close-invite-empty-state': (e) ->
      @$('.js-board-menu-inline-invite').addClass('hide')
      @$('a.js-simple-add-members.js-open-manage-board-members').removeClass('hide')

      trackUe('board menu', 'dismissed', 'invite empty state')

      Auth.me().dismiss(@_inviteEmptyStateKey())
      @renderMembers()
    'click .js-change-organization': (e) ->
      Util.stop(e)
      PopOver.toggle
        elem: @$('.js-change-organization')
        view: BoardSelectOrganizationView
        options: { @model, @modelCache }
    'click .js-change-visibility': (e) ->
      Util.stop(e)
      PopOver.toggle
        elem: @$('.js-change-visibility')
        view: ChangeBoardVisibilityView
        options: { @model, @modelCache }

  render: ->
    me = Auth.me()

    editable = @model.editable()

    data =
      canJoin: @model.canJoin()
      canInviteMembers: @model.canInviteMembers()
      canAssign: editable
      canChangeBackground: editable
      canChangeOrganization: @model.owned()
      canEnablePowerUps: editable
      hasBCPowerUps: me.hasBCPowerUps()
      hasGoldPowerUps: me.isFeatureEnabled('threePlugins')
      hasOrg: @model.hasOrganization()
      inviteEmptyStateDismissed: me.isDismissed(@_inviteEmptyStateKey())
      org:
        if (org = @model.getOrganization())?
          displayName: org.get('displayName')
          logoHash: org.get('logoHash')
          isBusinessClass: org.isBusinessClass()
          isEnterprise: org.isEnterprise()
      selfJoin: @model.allowsSelfJoin()
      useInviteEmptyState: simpleTest('boardSearchEmptyStates').get('enabled')
      useTabs: simpleTest('tabbedBoardMenu')?.get('tabbed')
      visibility: @model.getPermLevel()

    @$el.html(boardMenuTemplate(data))

    @renderMembers()

    @actionListView?.setElement(@$('.js-menu-action-list')[0])
    @renderActions()
    @renderActionCount()
    @renderEnabledPowerUpCount()
    @renderBackgroundPreview()
    @renderPowerUpDisableTimer()

    @

  renderBackgroundPreview: ->
    $preview = @$('.js-fill-background-preview').css
      'background-image': ''
      'background-color': ''

    if Backgrounds[@model.getPref('background')]?.tile?
      backgroundImageUrl = @model.getPref('backgroundImage')
    else if @model.getPref('backgroundImageScaled')? || @model.getPref('backgroundImage')?
      backgroundImageUrl =
        Util.previewBetween(@model.getPref('backgroundImageScaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl') ?
        @model.getPref('backgroundImage')

    else if @model.getPref('backgroundColor')?
      backgroundColor = @model.getClientBackgroundColor @model.getPref('background')
    else
      backgroundColor = @model.getClientBackgroundColor "blue"

    $preview.css
      'background-image':
        if backgroundImageUrl
          "url(#{backgroundImageUrl})"
        else
          ''
      'background-color': backgroundColor

    @

  getDateLastViewedActionsStorageKey: ->
    if @model.id
      "timeLastViewedActions-#{@model.id}"
    else
      null

  setDateLastViewedActions: (date) ->
    if (key = @getDateLastViewedActionsStorageKey())?
      Storage.set key, date.toISOString()
    return

  setDateLastViewedActionsAsNow: ->
    @setDateLastViewedActions new Date()
    return

  getDateLastViewedActions: ->
    if (key = @getDateLastViewedActionsStorageKey())?
      if (isoString = Storage.get key)?
        return new Date(isoString)
    null

  renderActionCount: ->
    @$('.js-unread-activity-count').empty()

    dateSince = @getDateLastViewedActions()
    maxNumber = 50

    if !dateSince?
      dateSince = new Date()
      @setDateLastViewedActions(dateSince)

    isCountable = (action) =>
      isNew = new Date(action.get('date')) > dateSince
      isNotMe = action.get('idMemberCreator') != Auth.me().id
      isNew && isNotMe

    count = 0
    for action in @model.getActions()
      if isCountable(action)
        count++

    # we show some comments on the top view which we consider viewed.
    # don't set the actions as viewed if it's 0, because…
    #   1. renderActionCount could have been called before actions were
    #   returned, and we don't want to erroneously set the time and ruin the
    #   count.
    #   2. it's not doing anything anyway
    if 0 < count <= @numActionsToShow
      @setDateLastViewedActionsAsNow()

    countText = count
    if count >= maxNumber
      countText = "#{maxNumber}+"

    if count > @numActionsToShow
      @$('.js-unread-activity-count').text countText

    data =
      count: countText
      hasCount: count > @numActionsToShow

    @$('.js-fill-activity-button').empty().append(
      templates.fill(
        'board_menu_more_activity_button'
        data
      )
    )

    @

  renderPowerUpDisableTimer: ->
    daysRemaining = @model.daysUntilPluginsDisable()
    if daysRemaining != null
      @$('.js-power-up-disable-timer')
        .removeClass('hide')
        .text(localizeCount 'days remaining', daysRemaining)
    else
      @$('.js-power-up-disable-timer').addClass('hide')

  getEnabledPowerUpCount: ->
    @model.get('powerUps').length + @model.boardPluginList.length

  renderEnabledPowerUpCount: ->
    # Show the new banner for the "one power-up for all teams launch"
    me = Auth.me()
    showNew = me && LatestPowerUpsMessage && !me.isDismissed(LatestPowerUpsMessage)

    if showNew
      @$('.js-enabled-power-up-count').text('')
      @$('.js-power-up-new').removeClass('hide')
    else
      @$('.js-power-up-new').addClass('hide')

      count = @getEnabledPowerUpCount()
      if count > 0
        @$('.js-enabled-power-up-count').text(formatNumber(count))
      else
        @$('.js-enabled-power-up-count').text('')
    @

  renderMembers: ->
    # It's possible that the board is part of a team we can't see
    hasOrg = @model.get('idOrganization')?
    org = @model.getOrganization()
    visibleMembers = @model.orderedVisibleMembers()
    if !(_.any(visibleMembers, (member) => @model.ownedByMember(member)))
      logError new Error("Board had no admins, id = #{@model.id}, #{visibleMembers.length} visibleMembers")

    me = Auth.me()
    isAffiliated =
      @model.isMember(me) ||
      @model.isObserver(me) ||
      org?.isMember(me)

    groups =
      if isAffiliated
        _.groupBy visibleMembers, (member) =>
          membership = @model.getMembershipFor(member)

          if @model.isVirtual(member)
            'invited'
          else if !membership?
            'other'
          else if membership.deactivated
            'deactivated'
          else if membership.memberType == 'observer'
            'observer'
          else if membership.orgMemberType? || (org?.getMembershipFor(member)?)
            'team'
          else if !hasOrg
            'member'
          else
            'other'
      else
        # If we're not affiliated with the board/team (e.g. it's a public board)
        # then we don't need to differentiate between the different sorts of
        # members
        {
          member: _.filter visibleMembers, (member) =>
            membership = @model.getMembershipFor(member)
            return !membership.deactivated && membership.memberType != 'observer'
        }

    sections = [
      { selector: '.js-list-members', list: groups.member }
      { selector: '.js-list-team-members', list: groups.team }
      { selector: '.js-list-invited-members', list: groups.invited }
      { selector: '.js-list-non-team-members', list: groups.other }
      { selector: '.js-list-observers', list: groups.observer }
      { selector: '.js-deactivated-members', list: groups.deactivated }
    ]

    # We can supress headings if there's only one type of member, and everyone
    # is either a 'member' or 'team' … which is the very common case
    #
    # We still want to show headings if everyone is e.g. 'other' and we're part
    # of the board or team, because that's a weird situation that deserves some
    # visibility
    hideHeadings = _.keys(groups).length == 1 &&
      (groups.member? || groups.team?)

    row = 9
    if WindowSize.fSmall
      row = 7

    rowLimit = 3

    limit = row * rowLimit
    # If the 'show hidden members' button is going to take up as much space as
    # the hidden members would, just show them.
    hideLimit = row * (rowLimit + 1)

    hiddenCount = 0
    showFullNames =
      simpleTest('tabbedBoardMenu')?.get('tabbed') &&
      visibleMembers.length <= 10

    for { selector, list } in sections
      list ?= []
      $section = @$(selector)
      $list = $section.find('.js-list')
      $heading = $section.find('.js-heading')

      $section.toggleClass('is-hidden', list.length == 0)
      $heading.toggleClass('is-hidden', hideHeadings)
      $section.toggleClass('is-partial-row', !showFullNames && list.length < row)

      isOverflow = list.length > hideLimit

      visibleMembers = list
      if isOverflow && !@showAllMembers
        hiddenCount += list.length - limit
        visibleMembers = visibleMembers.slice(0, limit)

      subviews = for member in visibleMembers
        if showFullNames
          @subview(MemberFullNameOnBoardView, member, { board: @model })
        else
          @subview(MemberOnBoardView, member, { board: @model })

      if $list.length
        @ensureSubviews(subviews, $list)

    @$('.js-show-extra-members').text((localizeCount 'show more members', hiddenCount))
    @$('.js-show-extra-members-button').toggleClass('is-shown', !@showAllMembers && hiddenCount > 0)
    @$('.js-hide-extra-members-button').toggleClass('is-shown', @showAllMembers)

    highlightAddMembers =
      simpleTest('tabbedBoardMenu')?.get('tabbed') &&
      !me.isDismissed(@_highlightAddMembersKey()) &&
      @model.memberList.length == 1 && Auth.isMe(@model.memberList.at(0))

    @$('.js-highlight-add-members').toggleClass('hide', !highlightAddMembers)

    if !simpleTest('boardSearchEmptyStates').get('enabled')
      @$('.js-simple-add-members').toggleClass('hide', highlightAddMembers)

    # a hack. we need to make sure all the members are in place before
    # refreshing the members draggable.
    @defer ->
      DragSort.refreshDraggableSidebarMembers()

    @

  _highlightAddMembersKey: ->
    "highlight-add-members-#{@model.id}"

  _inviteEmptyStateKey: ->
    "inline-invite-empty-state"

  showExtraMembers: (e) ->
    Util.stop(e)
    @showAllMembers = true
    @renderMembers()
    return

  hideExtraMembers: (e) ->
    Util.stop(e)
    @showAllMembers = false
    @renderMembers()
    return

  renderActions: ->
    @actionListView?.render()
    @

  showPowerUps: (e) ->
    Util.stop(e)
    me = Auth.me()
    if me && LatestPowerUpsMessage && !me.isDismissed(LatestPowerUpsMessage)
      me.dismiss(LatestPowerUpsMessage)

    @sidebarView.boardView.toggleDirectory()
    trackUe('board view', 'opens', 'Power-Up directory home page', '', '', 'by clicking Power-Ups button in sidebar')

    # Close the sidebar menu for window sizes that aren't extra large.
    if !WindowSize.fExtraLarge && !@sidebarView.boardView.directoryView
      @sidebarView.hideSidebar()

    daysRemaining = @model.daysUntilPluginsDisable()
    if daysRemaining != null
      track('Board Menu', 'Open Power-Ups', 'Power-Ups Timer Active')
    else
      track("Board Menu", "Open Power-Ups")
    return

  showCardFilter: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'filter'
    track("Board Menu", "Open Card Filter Menu")
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    track("Board Menu", "Open Stickers", "Via Default Menu")
    return

  changeBackground: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'background'
    track("Board Menu", "Open Change Background")
    return

  openActivity: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'activity'
    @setDateLastViewedActionsAsNow()
    track("Board Menu", "View All Board Activity")
    return

  openMore: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'more'
    track("Board Menu", "More Menu")
    return

  joinBoard: (e) ->
    Util.stop(e)
    if maybeDisplayMemberLimitsError($(e.target), @model, Auth.me())
      return
    @$('.js-join-board').remove()
    @model.joinBoard()
    track("Board Menu", "Join Board via Sidebar")
    return

  openAddMembers: (e) ->
    Util.stop(e)
    if maybeDisplayMemberLimitsError($(e.target), @model)
      return
    track("Board Menu", "Add Members via Sidebar Button")

    view = new BoardMembersView({ @model, @modelCache })
    view.loadOrgData()

    PopOver.toggle
      elem: $(e.target).closest('.js-open-manage-board-members')
      view: view

    return

  setOrganizationChangeListener: ->
    org = @model.getOrganization()

    # This is to prevent errors being thrown if getOrganization()
    # returns undefined
    if org
      @listenTo @model.getOrganization(),
        'change:memberships': @renderMembersDebounced

  loadOrganizationMembersData: ->
    idOrganization = @model.get('idOrganization')
    myPreviousIdOrganizations = Auth.me().previous('idOrganizations')
    myIdOrganizations = Auth.me().get('idOrganizations')

    wasInIdOrganizations = idOrganization in myPreviousIdOrganizations
    isNowInIdOrganizations = idOrganization in myIdOrganizations

    if not wasInIdOrganizations and isNowInIdOrganizations
      ModelLoader.loadOrganizationMembersData(idOrganization).then =>
        @renderMembersDebounced()

  remove: ->
    @setDateLastViewedActionsAsNow()
    super



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-sidebar-default-view.coffee